export default "__VITE_ASSET__DNv4FF8E__"